/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Sleep_Quality_1Inputs */

const en_us2_profile_editors_sleep_quality_1 = /** @type {(inputs: Profile_Editors_Sleep_Quality_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Very poor`)
};

const pt_br2_profile_editors_sleep_quality_1 = /** @type {(inputs: Profile_Editors_Sleep_Quality_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Péssima`)
};

const es_419_profile_editors_sleep_quality_1 = /** @type {(inputs: Profile_Editors_Sleep_Quality_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muy mal`)
};

const pt_pt2_profile_editors_sleep_quality_1 = /** @type {(inputs: Profile_Editors_Sleep_Quality_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Péssima`)
};

const fr_fr2_profile_editors_sleep_quality_1 = /** @type {(inputs: Profile_Editors_Sleep_Quality_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Très mauvaise`)
};

const de_de2_profile_editors_sleep_quality_1 = /** @type {(inputs: Profile_Editors_Sleep_Quality_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sehr schlecht`)
};

const it_it2_profile_editors_sleep_quality_1 = /** @type {(inputs: Profile_Editors_Sleep_Quality_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Malissimo`)
};

/**
* | output |
* | --- |
* | "Very poor" |
*
* @param {Profile_Editors_Sleep_Quality_1Inputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_sleep_quality_1 = /** @type {((inputs?: Profile_Editors_Sleep_Quality_1Inputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Sleep_Quality_1Inputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_sleep_quality_1(inputs)
	if (locale === "es-419") return es_419_profile_editors_sleep_quality_1(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_sleep_quality_1(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_sleep_quality_1(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_sleep_quality_1(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_sleep_quality_1(inputs)
	return en_us2_profile_editors_sleep_quality_1(inputs)
});
export { profile_editors_sleep_quality_1 as "profile-editors.sleep_quality_1" }